import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

// Import your actual images
import image1 from "../images/school_img_1.jpg";
import image2 from "../images/school_img_2.jpg";
import image3 from "../images/school_img_3.jpg";
import image4 from "../images/school_img_4.jpg";
import image5 from "../images/school_img_5.jpg";
import image6 from "../images/school_img_6.jpg";
import image7 from "../images/school_img_7.jpg";
import image8 from "../images/school_img_8.jpg";
import image9 from "../images/school_img_9.jpg";
import image10 from "../images/school_img_10.jpg";
import image11 from "../images/school_img_11.jpg";
import image12 from "../images/school_img_12.jpg";
import image13 from "../images/school_img_13.jpg";
import image14 from "../images/school_img_14.jpg";
// import image15 from "../images/school_img_15.jpg";
// import image16 from "../images/school_img_16.jpg";

const images = [
  { src: image1, caption: "Science Fair Excellence" },
  { src: image2, caption: "Sports Day Champions" },
  { src: image3, caption: "Art Exhibition" },
  { src: image4, caption: "Graduation Ceremony" },
  { src: image5, caption: "Music Festival" },
  { src: image6, caption: "Educational Field Trip" },
  { src: image7, caption: "Community Service" },
  { src: image8, caption: "Cultural Celebration" },
  { src: image9, caption: "STEM Innovation Lab" },
  { src: image10, caption: "Academic Awards" },
  { src: image11, caption: "Leadership Workshop" },
  { src: image12, caption: "Student Innovation Project" },
  { src: image13, caption: "Academic Excellence Award" },
  { src: image14, caption: "STEM Research Fair" },
  // { src: image15, caption: "Community Outreach Program" },
  // { src: image16, caption: "Innovation and Technology Expo" },
];

function GalleryPage() {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar */}
      <Navbar />

      {/* Gallery Section Header */}
      <div className="relative px-4 py-20 overflow-hidden text-center text-white bg-gradient-to-br from-yellow-500 via-green-700 to-gray-900">
        {/* Background Decorative Elements */}
        <div className="absolute w-32 h-32 bg-white rounded-full top-10 left-10 opacity-10 animate-pulse"></div>
        <div className="absolute w-48 h-48 bg-yellow-500 rounded-full bottom-10 right-10 opacity-10 animate-pulse"></div>
        
        <div className="relative z-10">
          <h1 className="mb-6 text-6xl font-extrabold tracking-tight uppercase md:text-7xl">
            <span className="text-white">Shinpex</span> <span className="text-yellow-500">Gallery</span>
          </h1>
          <div className="w-24 h-1 mx-auto mb-6 bg-yellow-500"></div>
          <p className="max-w-3xl mx-auto mb-4 text-xl font-medium md:text-2xl">
            Explore the vibrant life at <span className="font-bold text-yellow-500">Shinpex Academy</span>! 
            These images capture the essence of our community, achievements, and innovative learning environment.
          </p>
          <p className="max-w-2xl mx-auto text-lg text-gray-200">
            Scroll through and click on any photo to view it in full detail.
          </p>
        </div>
      </div>

      {/* Image Grid */}
      <div className="px-4 py-16 bg-gray-100">
        <div className="mx-auto max-w-7xl">
          <div className="mb-12 text-center">
            <h2 className="mb-4 text-4xl font-bold tracking-wide text-gray-900 uppercase">
              Moments of <span className="text-yellow-500">Excellence</span>
            </h2>
            <p className="text-xl text-gray-600">
              Witness the journey of academic excellence and innovation at Shinpex Academy
            </p>
          </div>
          
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {images.map((image, index) => (
              <div
                key={index}
                className="relative overflow-hidden transition-all duration-500 transform shadow-xl cursor-pointer rounded-2xl hover:shadow-2xl group hover:scale-105"
                onClick={() => handleImageClick(image)}
              >
                <img
                  src={image.src}
                  alt={`Shinpex Academy Gallery ${index + 1}`}
                  className="object-cover w-full h-64 transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 transition-opacity duration-300 opacity-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:opacity-90"></div>
                
                {/* Hover Overlay */}
                <div className="absolute inset-0 flex items-center justify-center transition-opacity duration-300 opacity-0 group-hover:opacity-100">
                  <div className="text-center text-white">
                    <svg className="w-12 h-12 mx-auto mb-2 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm5 3a2 2 0 11-4 0 2 2 0 014 0zm4.5 7a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" clipRule="evenodd" />
                    </svg>
                    <p className="text-sm font-medium">Click to view</p>
                  </div>
                </div>
                
                <p className="absolute text-lg font-bold text-white transition-all duration-300 transform translate-y-4 opacity-0 bottom-4 left-4 right-4 group-hover:opacity-100 group-hover:translate-y-0">
                  {image.caption}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal for Image Details */}
      {selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-y-auto bg-black bg-opacity-90 backdrop-blur-sm">
          <div className="relative w-full max-w-4xl p-6 overflow-hidden bg-white shadow-2xl rounded-2xl">
            <button
              onClick={closeModal}
              className="absolute flex items-center justify-center w-10 h-10 text-2xl font-bold text-gray-700 transition-all duration-300 rounded-full top-4 right-4 hover:text-white hover:bg-red-500"
            >
              ×
            </button>
            
            <img
              src={selectedImage.src}
              alt="Selected"
              className="object-contain w-full h-auto max-h-[70vh] mb-6 rounded-xl shadow-lg"
            />
            
            <div className="text-center">
              <h3 className="mb-4 text-2xl font-bold text-gray-900">
                {selectedImage.caption}
              </h3>
              <p className="mb-6 text-gray-600">
                Part of the vibrant community life at Shinpex Academy
              </p>
              <button
                onClick={closeModal}
                className="px-8 py-3 font-bold tracking-wide text-white uppercase transition-all duration-300 transform rounded-full shadow-lg bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 hover:scale-105"
              >
                Close Gallery
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default GalleryPage;